"use client";

import React from "react";
import { House, Trees, Shield, RotateCw, Phone, Octagon } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const inclusions = [{
  title: "Interior Treatments",
  description: "Targeted application in high-risk areas like kitchens, bathrooms, and entry points to eliminate pests where they hide.",
  icon: House
}, {
  title: "Exterior Treatments",
  description: "Comprehensive sweeping of eaves, windows, and doors to remove webs, nests, and prevent exterior infestations.",
  icon: Trees
}, {
  title: "Perimeter Protection",
  description: "A continuous barrier applied around your home's foundation to stop pests before they can enter.",
  icon: Shield
}, {
  title: "Free Re-treatments",
  description: "If pests return between scheduled visits, we return to re-treat your property at absolutely no additional cost.",
  icon: RotateCw
}, {
  title: "24/7 Support",
  description: "Round-the-clock customer service to address your pest concerns and schedule emergency visits when needed.",
  icon: Phone
}];
export default function PortCharlotteServiceInclusions() {
  return <section id="portcharlotteserviceinclusions" className="bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground uppercase tracking-tight mb-4">
            What's Included in Our Port Charlotte Service
          </h2>
          <div className="w-24 h-1.5 bg-foreground mx-auto mt-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 justify-center">
          {inclusions.map((item, i) => {
          const Icon = item.icon;
          return <Card key={i} data-index={i} className="rounded-none border-4 border-border shadow-none bg-card hover:bg-accent transition-colors duration-300 group">
                <CardHeader className="pb-4">
                  <div className="relative w-20 h-20 flex items-center justify-center mb-4">
                    <Octagon className="absolute inset-0 w-full h-full text-foreground stroke-[1.5] group-hover:text-background transition-colors duration-300" />
                    <Icon className="w-8 h-8 relative z-10 text-foreground group-hover:text-background transition-colors duration-300" />
                  </div>
                  <CardTitle className="text-2xl font-default font-bold uppercase tracking-wide text-foreground group-hover:text-background transition-colors duration-300">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-lg font-serif text-muted-foreground group-hover:text-background/90 transition-colors duration-300 leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-20 bg-primary text-primary-foreground p-8 md:p-12 lg:p-16 border-4 border-border rounded-none text-center max-w-5xl mx-auto relative overflow-hidden">
          {}
          <Octagon className="absolute -top-20 -left-20 w-64 h-64 text-primary-foreground/10 stroke-[0.5] rotate-12" />
          <Octagon className="absolute -bottom-20 -right-20 w-80 h-80 text-primary-foreground/10 stroke-[0.5] -rotate-12" />
          
          <div className="relative z-10">
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold mb-6 uppercase tracking-tight">
              Comprehensive Protection for Just <span className="text-accent">$35/Month</span>
            </h3>
            <p className="text-xl md:text-2xl font-serif mb-10 max-w-3xl mx-auto opacity-90">
              Get peace of mind with our affordable, all-inclusive pest control plan designed specifically for Port Charlotte homes. No hidden fees, just reliable results.
            </p>
            <Button asChild size="lg" className="rounded-full bg-background text-foreground hover:bg-background/90 text-lg md:text-xl px-8 py-8 font-default uppercase tracking-wide border-4 border-border shadow-none transition-transform hover:scale-105">
              <Link to="/ContactPage">
                Get Your Custom Port Charlotte Pest Control Quote
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}